export default __webpack_public_path__ + "static/media/offer.inline.a551ed5c.svg";